import api from './api';

const financeService = {
  getAccounts:     (token)       => api.get('/finance/accounts', token),
  getJournals:     (token)       => api.get('/finance/journals', token),
  createJournal:   (data, token) => api.post('/finance/journals', data, token),
  getInvoices:     (token)       => api.get('/finance/invoices', token),
  createInvoice:   (data, token) => api.post('/finance/invoices', data, token),
  getCashBook:     (type, token) => api.get(`/finance/cashbook/${type}`, token),
  getTrialBalance: (token)       => api.get('/finance/trial-balance', token),
  getBalanceSheet: (token)       => api.get('/finance/balance-sheet', token),
};

export default financeService;
